// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useCallback } from "react";

import {
  Type as StyledType,
  Option,
  SubHeading,
  Header,
  Heading,
} from "./styles";
import Icon from "src/icons";
import Radio from "src/components/Radio";
import * as colors from "src/styles/constants/colors";
import type { RoomId } from "src/types";

type Props = {
  privacy: string,
  roomId: RoomId,
  setAttribute: Function,
};

const Type = ({ privacy, roomId, setAttribute }: Props) => {
  const handleType = useCallback((privacyOption, e) => {
    e.preventDefault();
    setAttribute(roomId, { privacy: privacyOption });
  }, []);

  return (
    <StyledType>
      <Option
        selected={privacy === "content"}
        onClick={(e) => handleType("content", e)}
      >
        <Header>
          <Radio
            id="hideChatContent"
            checked={privacy === "content"}
            handleChange={() => {}}
          />

          <div>
            <Heading>
              <Icon type="lock" color={colors.primary} />
              {i18n.t(k.HIDE_ONLY_CHAT_CONTENT)}
            </Heading>
            <SubHeading>{i18n.t(k.ONLY_THE_CONTENTS_OF_THE_CONVE)}</SubHeading>
          </div>
        </Header>
      </Option>

      <Option
        selected={privacy === "full"}
        onClick={(e) => handleType("full", e)}
      >
        <Header>
          <Radio
            id="hideEverything"
            checked={privacy === "full"}
            handleChange={() => {}}
          />

          <div>
            <Heading>
              <Icon type="hidden" />
              {i18n.t(k.HIDE_EVERYTHING)}
            </Heading>
            <SubHeading>{i18n.t(k.CONVERSATIONS_WILL_BE_VISIBLE)}</SubHeading>
          </div>
        </Header>
      </Option>
    </StyledType>
  );
};

export default Type;
